// @flow
import WebComponent from '../webComponents/WebComponent';
import ClipboardJS from 'clipboard';
import tippy from 'tippy.js';

export default class ShareUrl extends WebComponent {
  constructor(props) {
    super(props);
    this.clipboard = null;
    this.tip = null;
    this.timer = null;
  }

	didMount() {
    const _self = this;
    const me = this.element;
		const {
			shareUrlSuccess,
		} = this.props;

		this.clipboard = new ClipboardJS(me, {
			text: function() {
				return window.location;
			}
		});

    this.tip = tippy.one(me, {
      arrow: true,
      theme: 'esp',
      placement: 'left',
      trigger: 'click',
      dynamicTitle: true,
    });

		this.clipboard.on('success', function(e){
		  const originTitle = me.title;
      me.title = shareUrlSuccess;

      _self.timer = setTimeout(function(){
        _self.tip.hide();
        me.title = originTitle;
      },2000);
 	  });
	}

  willUnMount() {
    clearTimeout(this.timer);
    this.clipboard.destroy();
    this.clipboard = null;
    this.tip = null;
    this.timer = null;
  }
}




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/ShareUrl.js